// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-grey[data-v-61a7a377] {\n    color: #9e9e9e;\n    font-size: small;\n}\n#margin-dialog-body[data-v-61a7a377] {\n    width: 100%;\n    background-color: white;\n    border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
